import { Box, Typography } from "@mui/material"

type Props = {
  src: string | null | undefined
  label?: string
}

export default function AudioPlayer({ src, label }: Props) {
  if (!src) {
    return (
      <Typography variant="body2" color="text.secondary" data-testid="audio-empty">
        {label || "No audio uploaded"}
      </Typography>
    )
  }
  return (
    <Box data-testid="audio-player">
      <audio controls src={src} style={{ width: "100%" }}>
        Your browser does not support audio playback.
      </audio>
    </Box>
  )
}
